import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const AdminRoute = () => {
  const { isLoading, data, isError } = useAuth();

  if (isLoading) return null;

  if (isError || !data?.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const roles = data.user?.role || [];
  const allowed = roles.includes("admin") || roles.includes("programmer");

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
